import actions from './actions';
import {RequestService as req} from '../../services/requestService';
import { Constants } from '../../config/constants';
const {
    fetchRosterUsersAction,
    LoadingStart, LoadingEnd,
    fetchRolesAction, fetchMainClubsAction, fetchSubClubsAction,
    fetchSessionsAction, fetchClassesAction, fetchFileSizeAction, fetchFileLengthAction,
    fetchUsersAction, fetchHodsAction, fetchStudentsAction, fetchStudentAcademicInfoAction,
    fetchSectionsAction, fetchClassRoomsAction, fetchProductCategoriesAction,
    fetchPeriodsAction, fetchSubjectsAction, fetchRoutinesAction, fetchSectionRoutinesAction, fetchAllSubjectsAction,
    fetchSessionAction, resetRoutinesFormAction, fetchSectionPeriodsAction,
    resetFilesFormAction,
    fetchTalentCandidatesAction,
    fetchCandidatesAction, fetchMessageCandidatesAction, fetchAcademicInfoAction,
    fetchCoordinatedStudentsAction, fetchCommentCandidatesAction,
    fetchCriteriaAction, fetchPositionsAction, fetchDepartmentsAction,
    resetSectionRoutinesFormAction, resetSectionPeriodsFormAction,
    fetchAttendanceCategoriesAction, fetchAppliedPositionsAction,
    fetchEmailsAction,
    fetchPromotedSessionsAction, fetchPromotedClassesAction, fetchPromotedSectionsAction,
    fetchClassRoutinesForTeacherAction, fetchTeachersAction,
    fetchSalaryMonthDeclarationsAction, fetchSalaryIncrementMonthDeclarationsAction,
    fetchPermissionsAction,
    fetchBulkDepartmentalUsersAction, fetchDepartmentalEmailsAction,fetchGroupEmailsAction
} = actions;
const loadingStart = () => async dispatch => dispatch(LoadingStart());
const loadingEnd = () => async dispatch => dispatch(LoadingEnd());

const fetchRoles = () => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}roles`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchRolesAction(cb)))
    };
};

// const fetchPermissions = () => {
//     return async dispatch => {
//         await req.getRequest({
//             url: `${Constants.UTILITIES}permissions`,
//             auth: 'bearer'
//         }, (cb) => dispatch(fetchPermissionsAction(cb)))
//     };
// };

// const fetchPermissions = () => {
//     return async dispatch => {
//         await req.getRequest({
//             url: `${Constants.UTILITIES}permissions`,
//             auth: 'bearer'
//         }, (cb) => {
//             // 1. Save to localStorage so Scope.js can see it immediately
//             // This bypasses the 4KB cookie limit!
//             if (cb && Array.isArray(cb)) {
//                 localStorage.setItem(Constants.STORAGE_USER_SCOPES, JSON.stringify(cb));
//             }
//
//             // 2. Dispatch to Redux as you normally do
//             dispatch(fetchPermissionsAction(cb));
//         })
//     };
// };

const fetchPermissions = () => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}permissions`,
            auth: 'bearer'
        }, (cb) => {
            if (cb) {
                // 1. Save the permissions array
                localStorage.setItem(Constants.STORAGE_USER_SCOPES, JSON.stringify(cb?.permissions));

                // 2. Update the userInfo in localStorage to include the superAdmin flag
                const existingUser = JSON.parse(localStorage.getItem(Constants.STORAGE_USER_INFO) || "{}");
                const updatedUser = { ...existingUser, superAdmin: cb?.superAdmin };
                localStorage.setItem(Constants.STORAGE_USER_INFO, JSON.stringify(updatedUser));
            }
            dispatch(fetchPermissionsAction(cb?.permissions));
        });
    };
};

const fetchSalaryIcrementMonthDeclarations = () => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}salary-increment-month-declarations`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSalaryIncrementMonthDeclarationsAction(cb)))
    };
};

const fetchSalaryMonthDeclarations = () => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}salary-month-declarations`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSalaryMonthDeclarationsAction(cb)))
    };
};

const fetchSessions = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}sessions`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchSessionsAction(cb))
        })
    };
};

const fetchPromotedSessions = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}sessions`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchPromotedSessionsAction(cb))
        })
    };
};

const fetchPositions = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}positions`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchPositionsAction(cb))
        })
    };
};

const fetchUtilityEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}getEmails`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchEmailsAction(cb))
        })
    };
};

const fetchAppliedPositions = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}appliedPositions`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchAppliedPositionsAction(cb))
        })
    };
};

const fetchAttendanceCategories = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}attendanceCategories`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchAttendanceCategoriesAction(cb))
        })
    };
};

const fetchDepartments = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}departments`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchDepartmentsAction(cb))
        })
    };
};

const fetchCriteria = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}criteria`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchCriteriaAction(cb))
        })
    };
};

const fetchSessionsWithType = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}sessions/type`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchSessionAction(cb))
        })
    };
};


const fetchClasses = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}classes`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchClassesAction(cb))
        })
    };
};

const fetchMainClubs = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}mainClubs`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchMainClubsAction(cb))
        })
    };
};

const fetchSubClubs = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}subClubs`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchSubClubsAction(cb))
        })
    };
};

const fetchPromotedClasses = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}classes`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchPromotedClassesAction(cb))
        })
    };
};

const fetchSections = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}sections`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchSectionsAction(cb))
        } )
    };
};

const fetchPromotedSections = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}sections`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchPromotedSectionsAction(cb))
        } )
    };
};

const fetchPerformanceSections = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}sections`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchSectionsAction(cb))
            const section = cb?.find((item) => item?.name === "A");
            if (section) {
                dispatch(fetchPerformanceSubjects({sessionId: section.session._id, classId: section.class._id, sectionId: section._id}))
                dispatch(fetchPerformanceAllSubjects({sessionId: section.session._id, classId: section.class._id}))
            }
        } )
    };
};


const fetchClassRooms = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}classrooms`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchClassRoomsAction(cb)))
    };
};

const fetchProductCategories = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}it-categories`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchProductCategoriesAction(cb)))
    };
};


const fetchPeriods = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}periods`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchPeriodsAction(cb)))
    };
};

const fetchSubjects = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}subjects`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSubjectsAction(cb)))
    };
};

const fetchPerformanceSubjects = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}subjects`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSubjectsAction(cb)))
    };
};

const fetchPerformanceAllSubjects = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}subjects/all`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAllSubjectsAction(cb)))
    };
};

const fetchFileSize = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}fileSize`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchFileSizeAction(cb)))
    };
};

const fetchFileLength = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}fileLength`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchFileLengthAction(cb)))
    };
};

const fetchUserSubjects = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}user/subjects`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSubjectsAction(cb)))
    };
};

const fetchTeacherSubjects = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}teacher/subjects`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSubjectsAction(cb)))
    };
};


export const resetUtilityRoutinesForm = () => dispatch => dispatch(resetRoutinesFormAction());
export const resetUtilityFilesForm = () => dispatch => dispatch(resetFilesFormAction());

const fetchUsers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}users`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchAppointedTeachers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}appointed-teachers`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchSubstituteTeachers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}users`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchTeachersAction(cb)))
    };
};

const fetchCustomRosterUsers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}custom/roster/users`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchCustomShiftUsers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}custom/shift/users`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchRosterUsers = () => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}roster/users`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchRosterUsersAction(cb)))
    };
};

const fetchAllUsers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}all/users`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchAllUsersEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}all/users/emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchDepartmentalEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}departmental/users/emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchDepartmentalEmailsAction(cb)))
    };
};

const fetchGroupEmails = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}group/emails`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchGroupEmailsAction(cb)))
    };
};

// Action Creator for multiple groups
const fetchBulkDepartmentalEmails = (queries) => {
    // queries = { departmentIds: [...], teacherSections: [...] }
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}departmental/users/emails/bulk`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchBulkDepartmentalUsersAction(cb)));
    };
};

const fetchAllUsersIncInactive = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}all/users/inc-inactive`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchAllTeachers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}getAllTeachers`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsersAction(cb)))
    };
};

const fetchAcademicInfo = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}academicInfo`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchAcademicInfoAction(cb)))
    };
};

const fetchStudentAcademicInfo = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}student/academicInfo`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchStudentAcademicInfoAction(cb)))
    };
};

const fetchCandidates = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}candidates`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCandidatesAction(cb)))
    };
};

const fetchTalentCandidates = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}talent-candidates`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchTalentCandidatesAction(cb)))
    };
};


const fetchMessageCandidatesCandidates = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}messageCandidates`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchMessageCandidatesAction(cb)))
    };
};

const fetchCommentCandidatesCandidates = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}messageCandidates`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCommentCandidatesAction(cb)))
    };
};


const fetchHods = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}users`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            dispatch(fetchHodsAction(cb))
        } )
    };
};

const fetchStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}students`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchStudentsAction(cb)))
    };
};

const fetchCoordinatedStudents = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}students/coordinated`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCoordinatedStudentsAction(cb)))
    };
};

const fetchRoutines = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}routines`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchRoutinesAction(cb)))
    };
};

export const clearPersonalRoutines = () => dispatch => {
    dispatch(fetchRoutinesAction({ routines: [], periods: [] }));
};

export const fetchTheTeacherRoutines = (queries) => {
    return async dispatch => {
        // 1. Immediately wipe out previous teacher's routines from Redux state
        dispatch(fetchRoutinesAction({ routines: [], periods: [] }));

        await req.getRequest({
            url: `${Constants.UTILITIES}routines`,
            queries,
            auth: 'bearer'
        }, (cb) => {
            // 2. If cb is empty or invalid, pass clean empty structures
            const cleanData = cb && (cb.routines || cb.periods)
                ? cb
                : { routines: [], periods: [] };

            dispatch(fetchRoutinesAction(cleanData));
        });
    };
};

const fetchClassRoutinesForTeacher = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}class-routines-for-teaches`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchClassRoutinesForTeacherAction(cb)))
    };
};

const fetchTeacherRoutines = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}teacher/routines`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchRoutinesAction(cb)))
    };
};

const fetchSectionRoutines = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}section/routines`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSectionRoutinesAction(cb)))
    };
};

const fetchSectionPeriods = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.UTILITIES}section/periods`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchSectionPeriodsAction(cb)))
    };
}

export const resetSectionRoutinesForm = () => dispatch => dispatch(resetSectionRoutinesFormAction());

export const resetSectionPeriodsForm = () => dispatch => dispatch(resetSectionPeriodsFormAction());

export {
    loadingStart, loadingEnd,
    fetchAllUsers, fetchRosterUsers,
    fetchRoles, fetchAppliedPositions, fetchPermissions,
    fetchSessions, fetchClasses, fetchSections, fetchFileSize, fetchFileLength, fetchPerformanceSections, fetchTeacherSubjects,
    fetchClassRooms, fetchPeriods, fetchSubjects, fetchUserSubjects,
    fetchUsers, fetchHods, fetchRoutines, fetchSectionRoutines, fetchSectionPeriods,
    fetchSessionsWithType, fetchStudents, fetchTeacherRoutines,
    fetchCandidates, fetchAcademicInfo, fetchStudentAcademicInfo,
    fetchCommentCandidatesCandidates, fetchMessageCandidatesCandidates,
    fetchCoordinatedStudents, fetchCustomRosterUsers, fetchProductCategories,
    fetchCriteria, fetchPositions, fetchDepartments, fetchAttendanceCategories,
    fetchUtilityEmails, fetchClassRoutinesForTeacher,
    fetchPromotedSessions, fetchPromotedClasses, fetchPromotedSections,
    fetchSubstituteTeachers, fetchSalaryMonthDeclarations, fetchSalaryIcrementMonthDeclarations,
    fetchAllTeachers, fetchAppointedTeachers, fetchCustomShiftUsers, fetchAllUsersIncInactive,
    fetchAllUsersEmails, fetchBulkDepartmentalEmails, fetchDepartmentalEmails, fetchGroupEmails, fetchTalentCandidates,
    fetchMainClubs, fetchSubClubs
};
